module.exports = __webpack_public_path__ + "img/top_index_bg.56712c58.jpg";